import React, { useContext, useState } from "react";
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';

import ImageGallery from "./imageGallery";
import { theme } from "../../../../theme";
import { formatEtaTime } from "../../../../utils";
import { formatMessage, getRecallVisitInfo } from "../service";
import Context from "../context";

const Right = ({message, ref}) => {
    const context = useContext(Context);
    const [isChipLoading, setIsChipLoading] = useState(false);

    const openRecallVisitInfo = async () => {
        const recall_visit_id = formatMessage(message).recall_visit_id;
        setIsChipLoading(true);
        await getRecallVisitInfo(recall_visit_id, context.dispatch);
        
        context.dispatch({
            type: 'IS_SHOW_RECALL_VISIT_INFO',
            is_show_recall_visit_info: true
        })

        setIsChipLoading(false);
    };

    return (
        <div className="msg right-msg" ref={ref}>
            <div 
                className="msg-bubble"
                style={{
                    backgroundColor: theme.right_msg_bg_color,
                    color: theme.right_msg_text_color
                }}
            >
                <div className="msg-info">
                    <div className="msg-info-name">{message.message_sender?.user_name} ({message.message_sender?.user_type})</div>
                    <div className="msg-info-time">{formatEtaTime(message.message_time)}</div>
                </div>

                <div className="msg-text">
                    {formatMessage(message).text}
                    {formatMessage(message).recall_visit_id > 0 ? (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Chip
                                label={isChipLoading ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <CircularProgress size={12} color="inherit" />
                                        <span>Loading</span>
                                    </div>
                                ) : "View"}
                                onClick={openRecallVisitInfo}
                                color="primary"
                                size="small"
                                style={{ marginBottom: '4px' }}
                                loading={true}
                                clickable={isChipLoading ? false : true}
                            />
                        </div>) : null}
                    {message.message_content?.files?.length > 0 ? <ImageGallery images = {message.message_content?.files}/> : null}
                </div>
            </div>
        </div>

        // <div className="row justify-content-end text-right mb-4" ref={ref}>
        //     <div className="col-auto">
        //         <div 
        //             className={`card`}
        //             style={{
        //                 backgroundColor: theme.right_msg_bg_color,
        //                 color: theme.right_msg_text_color
        //             }}
        //         >
        //             <div className="card-body py-2 px-3 text-white">
        //                 <div className="d-flex align-items-center justify-content-end text-sm opacity-6">
        //                     {/* <i className="ni ni-check-bold text-sm me-1"></i> */}
        //                     <small style={{fontWeight: '900'}}>{message.message_sender?.user_name} ({message.message_sender?.user_type})</small>
        //                 </div>
        //                 <p className="mb-1">
        //                     {message.message_content?.text}<br/>
        //                 </p>
        //                 <div className="col-12 p-0">
        //                     {message.message_content?.files?.length > 0 ? <ImageGallery images = {message.message_content?.files}/> : null}
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </div>
    );
}

export default Right;